<template lang="pug">
.events-list
  h1 {{ $t('Analysis.Event.title03') }}
    span.count {{ eventCount }}

  el-table(:data="events" cell-class-name="el-table-cell" row-class-name="el-table-row" v-loading="listLoading")
    el-table-column(width="200px" prop="created_at" :label="$t('Analysis.Event.datetime')" sortable="")
    el-table-column(prop="groups" :label="$t('Analysis.Event.group_name')" sortable="")
      template(slot-scope="props")
        template(v-for="group in props.row.groups")
          el-tag.group(size="mini") {{ group.name }}
    el-table-column(prop="device" :label="$t('Analysis.Event.device_name')" sortable="")
      template(slot-scope="props")
        img.device-image(:src="getCuonaImage(props.row.device)")
        span {{ props.row.device.name }}
    el-table-column(prop="customer" :label="$t('Analysis.Event.customer')" sortable="")
      template(slot-scope="props")
        img.thumbnail(:src="setCustomerImage(props.row.customer.image)")
        span.nickname {{ props.row.customer.nickname }}
    el-table-column(prop="customer.age_range" :label="$t('Analysis.Event.customer_age')" sortable="")
      template(slot-scope="props")
        span {{ showAge(props.row.customer.age_range) }}
    el-table-column(prop="customer.gender" :label="$t('Analysis.Event.customer_gender')" sortable="")
      template(slot-scope="props")
        span {{ showGender(props.row.customer.gender) }}
  .addlist
    el-button(v-if="displayMoreButton" size="mini" :loading="isEventlistLoading" @click="loadEvents()") {{ $t('Analysis.User.reload', {num:pageSize}) }}
</template>

<script>
import API from '@/api/analytics'

export default {
  props: [ "devices", "groups", "daterange" ],
  data() {
    return {
      images: {
        cube: require('@/assets/cuona_cube.svg'),
        seal: require('@/assets/cuona_seal.svg'),
        device_empty: require('@/assets/device_empty.svg')
      },
      listLoading: null,
      isEventlistLoading: null,
      eventCount: 0,
      pageSize: 10,
      events : [ ],
      currentPage: 0
    }
  },
  computed: {
    displayMoreButton() {
      return this.events.length !== this.eventCount;
    }
  },
  mounted() {
    this.loadEvents(true);
  },
  methods: {
    // 部分ローディングを生成
    makeLoading: function(name){
      return this.$loading({
        target: document.getElementById(name),
        fullscreen: false,
        background: 'rgba(255, 255, 255, 0.8)'
      });
    },

    // CUONAのアイコンを設定
    getCuonaImage: function(device) {
      return (device.type !== 'cube') ? this.images.seal : this.images.cube
    },

    setCustomerImage: function(url) {
      return url != null ? url : require("@/assets/default.svg");
    },

    loadEvents: function(reset, callback) {
      const obj = this;
      const reqParams = {
        event: this.$route.params.id,
        daterange: this.daterange,
        page_size: this.pageSize,
        page: reset ? 1 : this.currentPage + 1,
        groups: this.groups,
        nfc_uids: this.devices
      };
      API.getEventListForEvent(reqParams).then(function(response) {
        if (response && response.event_list_for_event) {
          obj.addEvents(response.event_list_for_event, reset);
          obj.currentPage = obj.currentPage + 1;
          if (callback) { callback(); }
        } else {
          // show error or something?
        }
      });
      if (!!reset) {
        API.getEventCountForEvent(reqParams).then(function(response) {
          if (response && response.event_count_for_event !== undefined) {
            obj.setCount(response.event_count_for_event);
            obj.currentPage = 0;
          }
        });
      }
    },
    addEvents: function (list, reset) {
      if (reset) {
        this.events = list;
      } else {
        this.events.push(...list);
      }
    },
    setCount: function (count) {
      this.eventCount = count;
    },
    showAge: function (age) {
      switch (age) {
        case 'from10to19': return this.$t('Analysis.User.age10');
        case 'from20to29': return this.$t('Analysis.User.age20');
        case 'from30to39': return this.$t('Analysis.User.age30');
        case 'from40to49': return this.$t('Analysis.User.age40');
        case 'from50to59': return this.$t('Analysis.User.age50');
        case 'from60to69': return this.$t('Analysis.User.age60');
        case 'over70': return this.$t('Analysis.User.age70');
      }
    },
    showGender: function (gender) {
      switch (gender) {
        case 'male': return this.$t('Analysis.User.male');
        case 'female': return this.$t('Analysis.User.female');
        case 'other': return this.$t('Analysis.User.other');
      }
    }
  },
  watch: {
    devices() {
      this.loadEvents(true);
    },
    groups() {
      this.loadEvents(true);
    },
    daterange() {
      this.loadEvents(true);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.events-list {
  position: relative;

  h1 {
    padding: 0;
    font-size: 16px;
    font-weight: normal;
  }

  .el-table {
    border-bottom: 1px solid $border;
  }

  .addlist {
    margin-top: 30px;
    text-align: center;
    .el-button {
      padding: 5px 30px;
    }
  }
}

.el-table ::v-deep {
  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0;
    color: #999;

    &:first-child {
      .cell {
        padding: 0;
      }
    }
  }
  td {
    padding: 10px 0;

    span.group {
      margin-right: 3px;
    }
    &:first-child {
      .cell {
        padding: 0;
      }
    }
  }
}

img.thumbnail {
  width: 24px;
  vertical-align: bottom;
  margin-right: 5px;
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}
</style>
